import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
export var formatToDMY = function formatToDMY(date) {
  if (!date) return undefined;
  var day = new Date(date).getDate();
  var month = new Date(date).getMonth() + 1;
  var year = new Date(date).getFullYear();
  return "".concat(day < 10 ? '0' + day : day, "/").concat(month < 10 ? '0' + month : month, "/").concat(year);
};